export { DocumentType, KYCCheckStatus, KYCCheckResultStatus, IdentityVerification } from '@guiker/user-shared'
